"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCEPTION_ADDRESSES = exports.SeoCleanUrlPrefixes = void 0;
exports.SeoCleanUrlPrefixes = [
    'komercion-tarack-',
    'arandznatun-karucapatoghic-',
    'chastnie-doma-novostroiki-',
    'grasenyakayin-taracq-',
    'kvartira-',
    'nedvizhimost-',
    'bnakaran-',
    'apartment-',
    'house-',
    'arandznatun-',
    'norakaruyc-',
    'sepakan-tun-',
    'new-',
    'kommercheskaya-',
    'komercion-',
    'ansharzh-guik-',
    'real-estate-',
    'chastniy-dom-',
    'novostroika-',
    'commercial-',
    'apartments-',
];
exports.EXCEPTION_ADDRESSES = [
    'malatia',
    'norq',
    'nor',
    'kanaker',
    'vayots',
];
